/* PN_MENTOR_PUBLIC_SHOWCASE_V1: public-only, opt-in projects + social links */
(() => {
  'use strict';
  const root = document.querySelector('[data-pnmp-page]');
  const section = root?.querySelector('[data-pnups-section]');
  if (!section) return;
  const slug = new URLSearchParams(window.location.search).get('slug');
  if (!slug || slug.length>180) return;
  const $=selector=>section.querySelector(selector);
  function safeURL(value) { try {const u=new URL(String(value||''));return ['http:','https:'].includes(u.protocol)?u.href:'';}catch{return '';}}
  function link(url,text,container) {const address=safeURL(url);if(!address)return;const a=document.createElement('a');a.href=address;a.target='_blank';a.rel='noopener noreferrer';a.textContent=text;a.className='pnups__link';container.append(a);}
  function render(data) {
    if(!data||!data.is_public)return;
    const links=$('[data-pnups-links]');links.replaceChildren();
    link(data.github_url,'GitHub ↗',links);
    link(data.portfolio_url,'Portfolio ↗',links);
    link(data.linkedin_url,'LinkedIn ↗',links);
    const projects=$('[data-pnups-projects]');projects.replaceChildren();
    const records=Array.isArray(data.projects)?data.projects:[];
    records.forEach(project=>{
      const article=document.createElement('article');article.className='pnups__project';
      const title=document.createElement('strong');title.textContent=project.title||'Project';article.append(title);
      if(project.description){const p=document.createElement('p');p.textContent=project.description;article.append(p);}
      const tech=document.createElement('div');tech.className='pnups__tech';
      if(Array.isArray(project.technologies))project.technologies.slice(0,8).forEach(t=>{const tag=document.createElement('span');tag.textContent=String(t);tech.append(tag);});
      if(tech.childElementCount)article.append(tech);
      const links=document.createElement('div');
      link(project.project_url,'View project ↗',links);
      link(project.github_url,'Source code ↗',links);
      if(links.childElementCount)article.append(links);
      projects.append(article);
    });
    const achievements=$('[data-pnups-achievements]');achievements.replaceChildren();
    const saved=Array.isArray(data.achievements)?data.achievements:[];
    saved.slice(0,20).forEach(item=>{const li=document.createElement('li');li.textContent=String(item);achievements.append(li);});
    section.hidden = !(links.childElementCount||projects.childElementCount||achievements.childElementCount);
  }
  async function load(){
    if(!window.PeerNestDB)return;
    try{
      const data=await window.PeerNestDB.request('rpc/pn_get_public_mentor_showcase_v1','',{method:'POST',body:{p_slug:slug}});
      render(Array.isArray(data)?data[0]:data);
    }catch(err){console.warn('[PeerNest] Optional mentor showcase not available:',err?.message||err);}
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',load);else load();
})();
